import numToWords from '../../../helpers/numToWord';

/**
 * Monto en letras como se escribe en el contrato: en mayúsculas y con la
 * preposición cuando la cifra termina en millón o millones
 * ("OCHO MILLONES DE PESOS M/CTE", pero "QUINIENTOS MIL PESOS M/CTE").
 *
 * Es la misma regla que aplican los comprobantes de recaudo sobre el texto que
 * devuelve numToWords; aquí se resuelve de una vez porque la cifra en letras va
 * incrustada en la redacción de las cláusulas.
 */
export const montoEnLetras = (valor) => {
    const letras = numToWords(valor);
    const preposicion = /(millón|millones)$/.test(letras) ? ' DE' : '';
    return `${letras.toUpperCase()}${preposicion} PESOS M/CTE`;
};

export default montoEnLetras;
